import React, {useCallback, useMemo, useRef} from 'react';
import chipImg1 from '../../../assets/images/chips/blue.png';
import chipImg2 from '../../../assets/images/chips/BrownGreen.png';
import chipImg3 from '../../../assets/images/chips/red.png';
import chipImg4 from '../../../assets/images/chips/green.png';
import chipImg5 from '../../../assets/images/chips/black.png';
import chipImg6 from '../../../assets/images/chips/purple.png';
import freeChipImg from '../../../assets/images/chips/free-chip.png';
import {abbreviateNumber, iframeService, platformMessageStore, useOutsideClick} from '@pascal/pascal-core';
import {observer} from 'mobx-react-lite';
import {uuid} from '../../../helpers/uuid';
import {doChipStore} from '../../../store/doChipStore';
import {autoBetStore} from '../../../store/autoBetStore';
import {useRouletteDoBetValidation} from '../../../hooks/useRouletteDoBetValidation';
import {gameStore} from '../../../store/gameStore';
import {freeBetStore, notificationStore, userInfoStore} from '@pascal/pascal-core/shared/core/store';
import {allChipsTotal} from '../../../helpers/chipsTotal';
import {betResponseCodeByName} from '../../../enums/betResponseCode';
import {soundService, soundTypes} from '../../../services/SoundService';
import {winningAmountStore} from '../../../store/winningAmountStore';
import {userSettingsStore} from '@pascal/pascal-core/shared/core/store/userSettingsStore';
import {PlatformErrorCodes} from "../../../enums/platformEnums";

export const MobileChipSection = observer(() => {
    const {
        selectedChip,
        setSelectedChip,
        setUndoBet,
        quickBets,
        reBet,
        getAllBetsModels: allBetsModels,
        setAllBetsModel,
    } = doChipStore;
    const {isBetsClosed} = gameStore;
    const settingsRef = useRef();
    const [opened, handleClick] = useOutsideClick(settingsRef);
    const {handleDoubleBetWithValid} = useRouletteDoBetValidation();
    const handleSelectChips = useCallback((chip) => setSelectedChip(chip), []);
    const {balance} = userInfoStore;
    const {activeFreeBet} = freeBetStore;
    const {setLastWin} = winningAmountStore;

    const handleUndo = () => {
        if (autoBetStore.autoBetModel) {
            autoBetStore.resetAutoBet();
        }
        if (allBetsModels.length && !isBetsClosed) {
            userSettingsStore.isSoundOn && soundService.play(soundTypes.chip);
            setLastWin(0);
            setUndoBet();
        }
    };

    const handleDouble = () => {
        if (reBet && !allBetsModels.length && allChipsTotal(reBet.lastBetModel) <= balance && !isBetsClosed) {
            if (autoBetStore.autoBetModel) {
                autoBetStore.resetAutoBet();
            }
            setLastWin(0);
            setAllBetsModel([reBet.lastBetModel]);
            return;
        }
        if (reBet && !allBetsModels.length && allChipsTotal(reBet.lastBetModel) > balance && !isBetsClosed) {
            !platformMessageStore.isShowAllNotification ? iframeService.sendErrorReceived(
                {"errorCode": PlatformErrorCodes.NotEnoughMoney}
            ) : notificationStore.setNotificationType(betResponseCodeByName.NotEnoughBalance)

            setTimeout(() => {
                notificationStore.setNotificationType(null);
            }, 1000);
            return;
        }

        if (allBetsModels.length && !isBetsClosed) {
            handleDoubleBetWithValid();
        }
    };

    const memoChip = useMemo(() => {
        const chipsImages = [chipImg1, chipImg2, chipImg3, chipImg4, chipImg5, chipImg6];
        return quickBets?.map((item, index) => ({...item, img: chipsImages[index]}));
    }, [handleSelectChips, selectedChip, quickBets, balance]);

    const selectedChipInfo = memoChip?.find((item) => item.chip === selectedChip);
    return (
        <div className='chips-section-wrp' ref={settingsRef}>
            <div className={`chips-section-cont ${opened ? 'switch' : ''}`}>
                {' '}
                {/*add/remove switch class*/}
                <div className='chips-main-container'>
                    <div className='chips-mob-icon' onClick={handleUndo}>
                        <i className='icon-arrow-back'/>
                    </div>
                    <div className='chips-all-wrp' onClick={activeFreeBet.id ? null : handleClick}>
                        {!activeFreeBet.id &&
                            memoChip
                                .filter((item, index) => index < 2)
                                .reverse()
                                .map(({img, chip}) => (
                                    <div className='chips-big-cont-block' key={uuid()}>
                                        <img src={img} alt=''/>
                                        <p>{abbreviateNumber(chip)}</p>
                                    </div>
                                ))}
                        <div className='chips-big-cont-block' key={uuid()}>
                            <img src={activeFreeBet.id ? freeChipImg : selectedChipInfo?.img} alt=''/>
                            <p>{abbreviateNumber(activeFreeBet.id ? activeFreeBet.amount : selectedChipInfo?.chip)}</p>
                        </div>
                    </div>
                    <div className='chips-mob-icon' onClick={handleDouble}>
                        <i className={reBet && !allBetsModels.length ? 'icon-spinner' : 'icon-double'}/>
                    </div>
                </div>
                <div className='chips-big-cont'>
                    {memoChip
                        .filter((item, index) => index < 6)
                        ?.reverse()
                        .map(({chip, img}) => (
                            <div
                                key={uuid()}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleSelectChips(chip);
                                }}
                                className={`chips-big-cont-block ${chip > balance ? 'disabled' : ''}`}
                            >
                                <img src={img} alt=''/>
                                <p>{abbreviateNumber(chip)}</p>
                            </div>
                        ))}
                    <div
                        className={`chips-big-cont-block active ${selectedChipInfo?.chip > balance ? 'disabled' : ''}`}>
                        <img src={selectedChipInfo?.img} alt=''/>
                        <p>{abbreviateNumber(selectedChipInfo?.chip)}</p>
                    </div>
                </div>
            </div>
        </div>
    );
});
